import styled from 'styled-components';

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
`;

export const Label = styled.span`
    width: 100%;
    font-weight: 700;
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin: 8px 0;
    color: ${({ theme }) => theme.colors.neutral700};
`;
